import If from "../../if"
import useConversationChatBox from "../use-conversation-chat-box"
import AIFooter from "./ai"
import LOFooter from "./lo"

const Footer = () => {
  const {
    takeOverFlag,
    takeOverConversation,
    sendReply,
    message,
    setReplyMessage
  } = useConversationChatBox()

  return (
    <div className="md:mx-6 md:my-4">
      <div className="bg-white p-3 md:rounded-lg md:border md:border-neutral-200">
        <If
          condition={takeOverFlag}
          then={
            <LOFooter
              takeOverConversation={takeOverConversation}
              sendReply={sendReply}
              message={message}
              setReplyMessage={setReplyMessage}
            />
          }
          else={<AIFooter takeOverConversation={takeOverConversation} />}
        />
      </div>
    </div>
  )
}

export default Footer
